import React from 'react';
import _ from 'lodash';
import Checkbox from 'material-ui/Checkbox';


export default class ToggleField extends React.Component {

  constructor(props) {
    super(props);
    var value = this.props.value ? true : false;
    this.state = { value };
    
  }

  componentWillReceiveProps = (e) => {
    var value = e.value ? true : false;
    if (value != this.state.value)
    {
      this.setState({ value });
    }
  }
    
  handleToggle = (event, value) => {
    this.setState({ value }, () => {
    });
  };

  getOption = (key) => {
    return this.props.options.filter( (o) => (o && o.key === key) ).pop();
  }

  render() {
    return (
      <Checkbox
        label={this.props.label}
        onCheck={this.handleToggle}
        checked={this.state.value}
         />
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Form/ToggleField.jsx